export const attachmentsTranslations = {
  fr: {
    title: "Pièces jointes",
    dropZone: "Glissez vos fichiers ici ou cliquez pour sélectionner",
    supportedFormats: "Images, PDF, documents Word (max 10MB)",
    invalidFileType: "Type de fichier non supporté",
    fileTooLarge: "Fichier trop volumineux (max 10MB)",
    uploadSuccess: "Fichier téléchargé avec succès",
    uploadError: "Erreur lors du téléchargement",
    uploading: "Téléchargement en cours",
    downloadError: "Erreur lors du téléchargement",
    viewError: "Erreur lors de l'ouverture",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
    deleteSuccess: "Fichier supprimé",
    deleteError: "Erreur lors de la suppression"
  },
  
  en: {
    title: "Attachments",
    dropZone: "Drop your files here or click to select",
    supportedFormats: "Images, PDF, Word documents (max 10MB)",
    invalidFileType: "Unsupported file type",
    fileTooLarge: "File too large (max 10MB)",
    uploadSuccess: "File uploaded successfully",
    uploadError: "Upload error",
    uploading: "Uploading",
    downloadError: "Download error",
    viewError: "Error opening file",
    confirmDelete: "Are you sure you want to delete this file?",
    deleteSuccess: "File deleted",
    deleteError: "Error deleting file"
  },
  
  es: {
    title: "Archivos adjuntos",
    dropZone: "Arrastra tus archivos aquí o haz clic para seleccionar",
    supportedFormats: "Imágenes, PDF, documentos Word (max 10MB)",
    invalidFileType: "Tipo de archivo no soportado",
    fileTooLarge: "Archivo demasiado grande (max 10MB)",
    uploadSuccess: "Archivo subido exitosamente",
    uploadError: "Error de carga",
    uploading: "Subiendo",
    downloadError: "Error de descarga",
    viewError: "Error al abrir archivo",
    confirmDelete: "¿Está seguro de que desea eliminar este archivo?",
    deleteSuccess: "Archivo eliminado",
    deleteError: "Error al eliminar archivo"
  }
};